var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBethistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.458 19.6367C16.6491 21.1689 14.4289 21.9565 12.1934 21.999C12.0634 19.6926 11.2037 17.4257 9.61133 15.5684L12.001 13.1787L18.458 19.6367ZM8.43164 16.748C9.67986 18.2446 10.3755 20.0479 10.5205 21.8877C8.7315 21.6211 7.00283 20.8741 5.54297 19.6367L8.43164 16.748ZM15.5693 9.61133C17.4266 11.2034 19.6937 12.0624 22 12.1924C21.9575 14.4288 21.17 16.6499 19.6377 18.458L13.1797 12L15.5693 9.61133ZM2.11328 13.4805C3.95394 13.6263 5.75557 14.3201 7.25293 15.5684L4.36426 18.457C3.12694 16.9972 2.37996 15.2694 2.11328 13.4805ZM10.8213 12L8.43164 14.3887C6.57438 12.7965 4.30727 11.9376 2.00098 11.8076C2.04347 9.57116 2.83092 7.35016 4.36328 5.54199L10.8213 12ZM11.8086 2.00098C11.9386 4.30728 12.7975 6.57439 14.3896 8.43164L12.001 10.8213L5.54297 4.36328C7.35197 2.83092 9.57297 2.04347 11.8086 2.00098ZM19.6377 5.54297C20.8751 7.00283 21.622 8.7315 21.8887 10.5205C20.048 10.3747 18.2464 9.67903 16.749 8.43164L19.6377 5.54297ZM13.4814 2.1123C15.2704 2.37895 16.9991 3.12589 18.459 4.36328L15.5693 7.25195C14.3212 5.75461 13.6264 3.95209 13.4814 2.1123Z",
    fill: "url(#paint0_linear_39_28528)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_39_28528",
    x1: 12.0005,
    y1: 2.00098,
    x2: 12.0005,
    y2: 21.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2B62E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#934600"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBethistory);
export default __webpack_public_path__ + "static/media/bethistory.71fc82b31ab76be5c318e52c3f8fad2c.svg";
export { ForwardRef as ReactComponent };